/* Review tabs — renders sections/ft-review-tabs.liquid from the Shopify file ft-review-tabs.json.
   There is no All tab, so a brand-new review appears once the nightly job has read it and filed it
   into its tabs. One instance per section. */
(function () {
  'use strict';

  var BLURB = {
    moto: 'reviews from riders', gym: 'reviews from the gym', run: 'reviews from runners',
    sticks: 'reviews about sweat and grip', others: 'reviews from people who switched brands',
    skeptic: 'reviews from people who doubted it', congestion: 'reviews about blocked noses', sleep: 'reviews about sleep'
  };
  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.6l2.6 5.5 6 .7-4.4 4.1 1.2 5.9L10 14.9l-5.4 2.9 1.2-5.9L1.4 7.8l6-.7z"/></svg>';
  var TICK = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M4.6 8.2l2.2 2.2 4.6-4.8" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var STARS5 = STAR + STAR + STAR + STAR + STAR;
  var lb; // one lightbox for the page

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function stars(n) {
    var s = el('span', 'ftr-stars'); s.setAttribute('role', 'img'); s.setAttribute('aria-label', n + ' out of 5 stars');
    s.innerHTML = '<span class="ftr-off">' + STARS5 + '</span><span class="ftr-on" style="width:' + (n * 20) + '%">' + STARS5 + '</span>';
    return s;
  }
  function ago(iso) {
    var d = Math.max(0, Math.round((Date.now() - new Date(iso + 'T00:00:00')) / 864e5));
    if (d < 1) return 'today';
    if (d < 14) return d + (d === 1 ? ' day ago' : ' days ago');
    if (d < 60) return Math.round(d / 7) + ' weeks ago';
    if (d < 365) return Math.round(d / 30) + ' months ago';
    var y = Math.round(d / 365); return y + (y === 1 ? ' year ago' : ' years ago');
  }
  function sized(url, w) { return url.replace(/width=\d+/, 'width=' + w); }

  // order inside a tab: hand-picked leads, then reviews whose main topic is this tab, then quality
  function rank(r, k) { return ((r.L && r.L[k]) || 0) * 100 + (r.c[0] === k ? 10 : 0) + (r.s || 0); }

  function openLb(r) {
    if (!lb) {
      lb = el('dialog', 'ftr-lb');
      lb.innerHTML = '<button class="ftr-lb__x" type="button" aria-label="Close">×</button><img alt=""><div class="ftr-lb__body"></div>';
      lb.querySelector('button').onclick = function () { lb.close(); };
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      document.body.appendChild(lb);
    }
    lb.querySelector('img').src = sized(r.img, 720);
    var body = lb.querySelector('.ftr-lb__body'); body.textContent = '';
    body.appendChild(stars(r.r));
    if (r.t) body.appendChild(el('b', null, r.t));
    body.appendChild(el('p', null, r.b));
    body.appendChild(el('span', 'ftr__count', r.n + ' · ' + r.p + ' · ' + ago(r.d)));
    if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
  }

  function card(r, feat) {
    var a = el('article', 'ftr-card' + (feat ? ' ftr-card--feat' : ''));
    if (r.img) {
      var b = el('button', 'ftr-card__img'); b.type = 'button'; b.setAttribute('aria-label', 'Open photo from ' + r.n);
      var i = new Image(); i.src = sized(r.img, 480); i.alt = ''; i.loading = 'lazy'; i.decoding = 'async';
      b.appendChild(i); b.onclick = function () { openLb(r); }; a.appendChild(b);
    }
    var top = el('div', 'ftr-card__top'); top.appendChild(stars(r.r));
    if (r.v) { var v = el('span', 'ftr-ver'); v.innerHTML = TICK; v.appendChild(document.createTextNode('Verified buyer')); top.appendChild(v); }
    a.appendChild(top);
    if (r.t) a.appendChild(el('h3', null, r.t));
    var p = el('p', 'ftr-clamp', r.b); a.appendChild(p);
    var by = el('div', 'ftr-card__by');
    by.appendChild(el('b', null, r.n)); by.appendChild(el('span', null, '·')); by.appendChild(el('span', null, r.p));
    by.appendChild(el('span', null, '·')); by.appendChild(el('span', null, ago(r.d)));
    a.appendChild(by);
    return a;
  }

  function init(root) {
    if (root.dataset.ftrReady) return; root.dataset.ftrReady = '1';
    var rail = root.querySelector('[data-rail]'), countEl = root.querySelector('[data-count]');
    var tabs = [].slice.call(root.querySelectorAll('.ftr-tab'));
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    var data = [], current = (root.querySelector('.ftr-tab[aria-selected="true"]') || tabs[0]).dataset.k;

    function list(k) {
      return data.filter(function (r) { return r.c.indexOf(k) > -1; })
        .sort(function (a, b) { return rank(b, k) - rank(a, k); });
    }
    function navState() {
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
    }
    function show(k) {
      current = k;
      var items = list(k);
      tabs.forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.k === k)); });
      var frag = document.createDocumentFragment();
      items.forEach(function (r, i) { frag.appendChild(card(r, i === 0)); });
      rail.textContent = ''; rail.appendChild(frag); rail.scrollLeft = 0;
      countEl.textContent = items.length + ' ' + BLURB[k];
      // "Read more" only where the text is actually clamped
      requestAnimationFrame(function () {
        [].forEach.call(rail.querySelectorAll('p.ftr-clamp'), function (p) {
          if (p.scrollHeight <= p.clientHeight + 2) return;
          var m = el('button', 'ftr-more', 'Read more'); m.type = 'button';
          m.onclick = function () { var shut = p.classList.toggle('ftr-clamp'); m.textContent = shut ? 'Read more' : 'Show less'; };
          p.parentNode.insertBefore(m, p.nextSibling);
        });
        navState();
      });
    }
    function counts() {
      tabs.forEach(function (b) {
        b.hidden = list(b.dataset.k).length < 3;
      });
    }
    function faces() {
      var box = root.querySelector('[data-faces]');
      if (root.dataset.showFaces !== 'true') return;
      box.textContent = '';
      data.filter(function (r) { return r.img && !r.x; })
        .sort(function (a, b) { return b.s - a.s; }).slice(0, 12)
        .forEach(function (r) {
          var b = el('button', 'ftr-face'); b.type = 'button'; b.setAttribute('aria-label', 'Photo from ' + r.n);
          var i = new Image(); i.src = sized(r.img, 160); i.alt = ''; i.loading = 'lazy'; i.decoding = 'async'; b.appendChild(i);
          b.onclick = function () { openLb(r); };
          box.appendChild(b);
        });
    }

    tabs.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.k); }); });
    function step(dir) {
      var c = rail.querySelector('.ftr-card'); if (!c) return;
      var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({ left: dir * (c.offsetWidth + 12) * 3, behavior: still ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', navState, { passive: true });
    var all = root.querySelector('[data-all]');
    if (all) all.addEventListener('click', function (e) {
      var w = document.querySelector('.jdgm-review-widget, #judgeme_product_reviews');
      if (w) { e.preventDefault(); w.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });

    fetch(root.dataset.src, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (json) {
        data = json.r || [];
        counts(); faces(); show(current);
      })
      .catch(function () { root.hidden = true; });
  }

  function boot() { [].forEach.call(document.querySelectorAll('.ftr[data-src]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
